// src/utils/iconResolvers.js
// Migrated verbatim from prototype/between-the-lines-v2.html lines 5437-5455.

import {
    IconMail, IconInstagram, IconUser, IconBookOpen,
    IconFeather, IconMessage, IconCards,
    IconHeadphones, IconQuestion, IconEdit
} from '../components/icons.jsx';

export const getContactIcon = (key) => {
    if (key === 'mail') return IconMail;
    if (key === 'instagram') return IconInstagram;
    if (key === 'user') return IconUser;
    if (key === 'book') return IconBookOpen;
    if (key === 'feather') return IconFeather;
    if (key === 'message') return IconMessage;
    if (key === 'cards') return IconCards;
    return IconMail;
};

export const getFeatureIcon = (key) => {
    if (key === 'feather') return IconFeather;
    if (key === 'headphones') return IconHeadphones;
    if (key === 'cards') return IconCards;
    if (key === 'question') return IconQuestion;
    if (key === 'message') return IconMessage;
    if (key === 'edit') return IconEdit;
    return IconFeather;
};
